<template>
  <div class="amex-landing">
    <AmexHeader>
      <PoweredByMobi />
    </AmexHeader>
    <div class="mobile-wrapper">
      <div class="mobile-overlay">
        <div class="img"></div>
        <div class="text-primary"><b>Access AMEX Trip Planner from your desktop browser</b></div>
        <div class="text-secondary">
          Mobile devices are currently not supported. Plan your next trip from your web browser on your computer or
          laptop.
        </div>
      </div>
      <section class="visual-header">
        <div class="header-container">
          <div class="visual-header__text">
            <h1>Explore your next destination with Amex&#174; Trip Planner</h1>
            <p>Amex Trip Planner is new from American Express and is looking for your feedback to make it better.</p>
          </div>
          <div class="visual-header__login">
            <h2 class="start-heading">Start Planning</h2>
            <p>
              Eligible American Express&#174; Card Members get complimentary access to test out Amex Trip Planner
              through 02/28/2023.
            </p>
            <!-- <div class="checkbox-label" v-if="isCheckboxVisible">
            <input id="terms-and-conditions" type="checkbox" v-model="termsAccepted" />
            <label for="terms-and-conditions">I agree to the Terms & Conditions</label>
            <CheckMark class="check-icon" />
          </div> -->
            <div class="read-terms">
              <a href="#" @click.prevent="onShowFAQ" ref="tc"> <strong> See FAQs/Program Terms </strong></a>
            </div>

            <button class="core-button" @click="loginAction">{{ logInText }}</button>
          </div>
        </div>
      </section>
      <section class="content">
        <h2>Dream about Future Travel</h2>
        <div class="content-wrapper">
          <div class="content-block">
            <img src="/img/new-dest-img.png" alt="new destinations" />
            <h3 class="section-heading">Explore Your Next Destination</h3>
            <p>
              Whether it's a snowy weekend on the slopes or a tropical getaway on sandy beaches, you can tailor your
              search by budget, flight times, activities, interests and more.
            </p>
          </div>
          <div class="content-block">
            <img src="/img/curated-by-img.png" alt="new destinations" />
            <h3 class="section-heading">Curate Your To Do List</h3>
            <p>
              Explore restaurants, experiences and events to create an unforgettable stay. We'll help by letting you
              know what's top-rated for your location and provide reviews from other travelers.
            </p>
          </div>
          <div class="content-block">
            <img src="/img/org-trip-img.png" alt="new destinations" />
            <h3 class="section-heading">Manage Your Itinerary</h3>
            <p>
              We'll test and suggest trip plans you might like, then you can edit, organize and view your personalized
              itinerary all in one place.
            </p>
          </div>
        </div>
      </section>
      <PoweredByMobiFooter />
    </div>
  </div>
</template>

<script>
import FAQModal from '@common/modal/faq-modal.vue';
import PoweredByMobi from '@common/powered-by-mobi.vue';
import AmexHeader from '../main-menu/main-menu.vue';
import PoweredByMobiFooter from '@common/powered-by-mobi-footer.vue';
import {isLoggedIn, amexLogin, getUserId} from '@/services/amex-auth';
import {useRouter} from '@/router';
import {RouterAliases} from '@/router/routerAliases';

// @ts-ignore
import MdModalDialog from 'vue-material-modal-dialog';
import 'vue-material-modal-dialog/dist/components.css';
// @ts-ignore
import {MdDialog} from 'vue-material/dist/components';
import Vue from 'vue';
import {validateToken} from './validateToken';
import {trackBtnClick} from '@/store/api/trackBtnClick';
import {trackSource} from './trackSource';

Vue.use(MdDialog);
Vue.use(MdModalDialog);

export default {
  components: {PoweredByMobi, AmexHeader, PoweredByMobiFooter},
  name: 'AmexLanding',
  mounted() {
    const userId = getUserId();
    const location = 'landing_page';
    const params = new URL(document.location).searchParams;
    const source = params.get('utm_source');
    if (source) {
      localStorage.setItem('utm_source', source);
      trackSource(source, location, userId);
    }
  },
  computed: {
    logInText() {
      return isLoggedIn() ? 'Continue' : 'Log In';
    },
  },
  methods: {
    async validateToken() {
      const loginStatus = await validateToken();
      if (loginStatus) {
        const userId = getUserId();
        trackBtnClick(userId, `${process.env.VUE_APP_BASE_URL}/discovery`.replace(/\/+/g, '/'));
        const router = useRouter();
        router.push({name: RouterAliases.DISCOVERY_VIEW});
      } else {
        amexLogin();
      }
    },
    loginAction() {
      return isLoggedIn() ? this.validateToken() : amexLogin();
    },
    onShowFAQ() {
      const app = document.querySelector('#app');
      app.inert = true;
      this.$modal
        .show(FAQModal, {})
        .catch(() => null)
        .finally(() => {
          app.inert = false;
          this.$refs.tc.focus();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.visual-header {
  background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%),
    url('/img/amex-landing-bg-img.png');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 130px 0px;
}

.visual-header__text {
  max-width: 650px;

  & h1 {
    font-family: var(--font-family);
    font-style: normal;
    font-weight: 400;
    font-size: 58px;
    line-height: 59px;
    margin: 0;
  }

  & p {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    margin-right: 50px;
  }

  color: #ffffff;
}

.visual-header__login {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 315px;
  padding: 20px 30px 30px;
  background: #fff;
  border-radius: 4px;
  margin-left: 100px;
  text-align: center;

  & .start-heading {
    font-family: var(--font-family);
    font-style: normal;
    font-weight: 400;
  }

  & p {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
    color: #737373;
  }
}

.header-container {
  margin: auto;
  display: flex;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  max-width: var(--page-container-width, 1240px);
}

.core-button {
  align-self: stretch;
  --core-btn-bg-color: var(--b-cta-bg, #006fcf);
  --core-btn-border: var(--b-cta-bg-hover, #006fcf);
  --core-btn-color: #fff;
  height: 40px;
  line-height: 41px;
  color: var(--core-btn-color);
  text-decoration: none !important;
  border-radius: 10px;
  padding: 0 60px;
  background-color: var(--core-btn-bg-color);
  border: 1px solid var(--core-btn-border);
  font-size: 16px;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  white-space: nowrap;
}

.content {
  margin: 75px auto;
  & h2 {
    font-family: var(--font-family);
    font-style: normal;
    font-weight: 400;
    font-size: 40px;
    line-height: 22px;
    text-align: center;
    color: #333333;
    padding-bottom: 20px;
  }
}

.content-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  max-width: var(--page-container-width, 1240px);
  margin: 0 auto;
}
.content-block {
  max-width: 320px;
  min-width: 200px;
  margin: 0 20px;
  flex: 1;
  text-align: center;

  & .section-heading {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    /* identical to box height */

    text-align: center;

    color: #333333;
  }

  & p {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
    /* or 22px */

    text-align: center;

    color: #737373;
  }
}

.read-terms {
  margin-top: -15px;
  margin-bottom: 15px;
  & a {
    color: var(--b-cta-bg, #006fcf);
  }
  & a:hover {
    color: var(--b-cta-bg-hover, #006fcf);
  }
}
</style>
